import React, { Fragment } from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import Expense from "./Expense";
import ReactLogo from "../../homeLogotodo.svg";
import "./Home.css";


const Home = () => {
    const bgColor = useSelector(state => state.theme.bgColor);
    const isToken = localStorage.getItem("token");
    return (
        <Fragment>
            <div className={bgColor === false ? "home" : "home negative"}>
                <div>
                    <h1>Welcome to expense Tracker!</h1>
                    {isToken && <p className={bgColor === false ? "" : "negative"}>Your profile is incomplete.
                        <NavLink to="/profile" className={bgColor === false ? "link" : "link-negative"}>Complete now</NavLink>
                    </p>}
                </div>
                <div>
                    <img src={ReactLogo} alt="tracker" className="logo" />
                </div>
            </div>
            <Expense />
        </Fragment>
    );
}

export default Home;